import React, { useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { api, formatApiError } from "../../pages/Admin";

export default function ForgotPasswordForm({ onBack }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(data.message);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="forgot-password-form">
      <h1 className="text-2xl font-semibold">Forgot password</h1>
      {sent ? (
        <p className="text-sm text-slate-700" data-testid="forgot-password-sent">{sent}</p>
      ) : (
        <>
          <p className="text-sm text-slate-600">Enter your admin email and we&rsquo;ll send you a reset link.</p>
          <div>
            <Label htmlFor="forgot-email">Email</Label>
            <Input id="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-email-input" className="mt-2 h-11" />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="forgot-password-error">{error}</p>}
          <Button type="submit" disabled={loading || !email} data-testid="forgot-password-submit"
            className="w-full h-11 rounded-full bg-slate-900 hover:bg-slate-800 text-white">
            {loading ? "Sending…" : "Send reset link"}
          </Button>
        </>
      )}
      <button type="button" onClick={onBack} data-testid="forgot-back-btn" className="text-sm text-sky-700 hover:underline">
        Back to login
      </button>
    </form>
  );
}
